import React from 'react'
import { useAppSelector } from 'reduxTyped'
import { l, SectionMessage } from '@manychat/manyui'

import { GoalTypeHint } from 'apps/aiAutomation/components/EngagementGoalEditor/components/GoalTypeHint'
import { MAX_GOALS_NUMBER } from 'apps/aiAutomation/lib/goals'
import { AiAutomationEngagementGoalSelectors } from 'apps/aiAutomation/store/engagementGoal'
import { GoalStatus } from 'shared/api/requests/aiEngagementGoal/schemas'

import { useSelectedGoalData } from '../../hooks/useSelectedGoalData'

export const ContextualHint = () => {
  const { selectedGoal, goalType } = useSelectedGoalData()

  const isActiveGoalLimitReached = useAppSelector(
    AiAutomationEngagementGoalSelectors.getIsActiveGoalLimitReached,
  )

  return (
    <div>
      {selectedGoal?.status !== GoalStatus.ACTIVE && isActiveGoalLimitReached && (
        <SectionMessage
          className="m-b-lg"
          variant="warning"
          title={l.translate("You've reached your {maxGoals} live goal limit", {
            maxGoals: MAX_GOALS_NUMBER,
          })}
          description={l.translate(
            'You can only save this as a draft and go live later by deactivating another goal.',
          )}
        />
      )}

      <GoalTypeHint type={goalType} />
    </div>
  )
}
